import React from "react";
import { LocalizationHelperInstance } from "utils/helpers";
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import FAQHelper from "./faqHelper";
import SupportTicketCreationFormContainer from "./forms/creationFormContainer";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";

function useSupportTicketCreateDialog() {
  const getDialog = (
    onActionSuccess?: () => void,
    onActionClose?: () => void,
    defaultMessage?: string,
    hideOverlay?: boolean,
    onFormUpdate?: (values: any, isValid: boolean) => void
  ): DialogProps => {
    return {
      id: "support-case-creation-dialog",
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.NewMessage),
      titleIcon: IconDefinitionConstants.WCommentDots,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Send),
          successMessage: TranslationKeys.SupportIssue.CreateSuccessMessage,
        },
      ],
      dialogType: DialogEnums.DialogType.Content,
      children: <SupportTicketCreationFormContainer defaultMessage={defaultMessage} onFormUpdate={onFormUpdate} />,
      maxWidth: "sm",
      overlayAnimationComponent: hideOverlay ? <></> : <FAQHelper />,
      onSubmit: onActionSuccess,
      onClose: onActionClose,
      customCloseConfirmation: {
        title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.FormExitWarningMessage),
        content: LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.SupportIssue.UnansweredQuestionTextSupportStep
        ),
      },
    };
  };

  return { getDialog };
}

export default useSupportTicketCreateDialog;
